<!-- Dokumentenbezogene Kommentare -->
<mat-card class="card-base">
    <mat-card-content class="card-content">
        <mat-card-header>
            <mat-card-title class="card-title">
                Dokumentenbezogene Kommentare
            </mat-card-title>
        </mat-card-header>
        @if (!permission.isReadOnly()) {
            <app-document-upload (filesSelected)="onDocumentsAdded($event)" />
        }
        <table mat-table [dataSource]="data.documentTableViewModel()" style="background-color: transparent;">
            <ng-container matColumnDef="path">
                <th mat-header-cell *matHeaderCellDef>Pfad</th>
                <td mat-cell *matCellDef="let row">{{row.document.uri}}</td>
            </ng-container>
            <ng-container matColumnDef="document">
                <th mat-header-cell *matHeaderCellDef>Dokument</th>
                <td mat-cell *matCellDef="let row">
                    <div class="document-sub-grid">
                        <mat-chip> {{row.document.displayName}}</mat-chip>
                        @if (!permission.isReadOnly()) {
                            <button mat-icon-button (click)="removeDocumentFromCheck(row.document.guid)" color="warn"><mat-icon>delete</mat-icon></button>
                        }
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="comments">
                <th mat-header-cell *matHeaderCellDef>Kommentare</th>
                <td mat-cell *matCellDef="let row">
                    @if (!permission.isReadOnly()) {
                        <form (ngSubmit)="addComment(docCommentInput, row.document.guid, 0)" class="new-comment-formfield">
                            <mat-form-field style="flex: 1;">
                                <input matInput placeholder="Kommentar hinzufügen…" name="newDocComment" #docCommentInput >
                            </mat-form-field>
                            <button matButton="outlined" type="submit">
                            Speichern</button>
                        </form>
                    }
                    <div class="comments-sub-grid">
                        <app-comment-component
                          [comments]="row.comments | sortCommentsDesc"
                          [currentUser]="data.currentUser()"
                          [currentCheckStatus]="data.checkInfoViewModel()?.status"
                          [isReadOnly]="permission.isReadOnly()"
                          (doneToggled)="onCommentDoneToggled($event)"
                          (severityToggled)="onCommentSeverityToggled($event)"
                          (commentDeleted)="onCommentDeleted($event)" />
                    </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </mat-card-content>
</mat-card>

